import RegForms from './RegFormsContainer';
export default RegForms;
